var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoAddToCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.52,
    height: 28.356,
    viewBox: "0 0 25.52 28.356",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "so-add-to-cart",
    d: "M10.089,3.418V9.089H28.52l-2.836,9.924h-15.6v2.836H24.267a1.418,1.418,0,0,1,0,2.836H8.671a1.418,1.418,0,0,1-1.418-1.418V4.836H4.418A1.418,1.418,0,0,1,4.418,2H8.671A1.418,1.418,0,0,1,10.089,3.418ZM7.253,28.229A2.127,2.127,0,1,0,9.38,26.1,2.127,2.127,0,0,0,7.253,28.229Zm12.76,0A2.127,2.127,0,1,0,22.14,26.1,2.127,2.127,0,0,0,20.013,28.229Z",
    transform: "translate(-3 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoAddToCart);
export default __webpack_public_path__ + "static/media/so-add-to-cart.21986168251b03e57c75fa7e8531cea8.svg";
export { ForwardRef as ReactComponent };